import { Platform } from "react-native";

/**
 * Enter und Leertaste lösen einen Button aus.
 * role=link ohne href bleibt auf React Native Web ein div: der PressResponder
 * ruft onPress dann nicht auf. role=button wird ein button-Element.
 */
export function buttonKeyActivates(key: string | undefined): boolean {
  return key === "Enter" || key === " " || key === "Spacebar";
}

type KeyEvent = {
  key?: string;
  nativeEvent?: { key?: string };
  preventDefault?: () => void;
};

/** Auf Web übernimmt das button-Element den Klick. Sonst löst die Taste selbst aus. */
export function activateButtonOnKey(event: KeyEvent, onPress: () => void): void {
  const key = event.nativeEvent?.key ?? event.key;
  if (!buttonKeyActivates(key)) return;
  if (Platform.OS === "web") return;
  event.preventDefault?.();
  onPress();
}
